import { AssetFileTypeEnum } from "../DialogueEnum";
import { IDialogueConfig } from "../types";

export const config: IDialogueConfig = {
  sentences: [
    {
      charName: "神似蛋饺的生物",
      content: "呜...",
      assets: {},
    },
    {
      charName: "神似蛋饺的生物",
      content: "我这是...在哪里？",
      assets: {},
    },
    {
      charName: "我",
      content: "蛋饺...说话了...",
      assets: {},
    },
    {
      charName: "神似蛋饺的生物",
      content:
        "我想起来了！我是来这里寻找富有创造力的灵魂的！为了拯救破碎的饼次元！",
      assets: {},
    },
    {
      charName: "我",
      content: "啊？穿越剧是吧？（盯）",
      assets: {},
    },
    {
      charName: "神似蛋饺的生物",
      content:
        "自我介绍一下，我叫饼饼，反正你可以暂时这么叫我。（这个小东西自说自话的嘟囔起来）。我可能需要你的一点帮助...",
      assets: {
        figure: {
          url: "/game/star/actions/jump.gif",
          fileType: AssetFileTypeEnum.IMAGE,
        },
      },
    },
    {
      charName: "饼饼",
      content: "我可能...需要暂时在这里借住一段时间...",
      assets: {},
    },
    {
      charName: "饼饼",
      content:
        "不必担心，我不会在这里吃白饭的。我可以为这个家贡献颜值。还会卖萌打滚。有了我你的生活不会寂寞的！",
      assets: {
        figure: {
          url: "/game/star/actions/jump.gif",
          fileType: AssetFileTypeEnum.IMAGE,
        },
      },
    },
    {
      charName: "我",
      content: "？？ 这里礼貌么?",
      assets: {},
    },
    {
      charName: "饼饼",
      content:
        "的确是有点冒昧...我的意思是...请收留我吧！没有获取到足够的创造力，我就回不去饼次元了（这个叫饼饼的蛋饺边说边好像边哭了起来）",
      assets: {},
    },
    {
      charName: "我",
      content:
        "（原来你是知道冒昧的啊混蛋）啊这...（我挠了挠头）, 蛋饺住在我家？",
      assets: {},
    },
    {
      charName: "我",
      content:
        "你先别急，我考虑一下。今天你先在这里吧，家里随便坐，我得冷静一下...",
      assets: {},
    },
    {
      charName: "饼饼",
      content: "好wu！(好像突然恢复了一些元气)",
      assets: {},
    },
  ],
};
